export const GET_TIMEZONES = 'GET_TIMEZONES'
export const GET_TIMEZONES_SUCCESS = 'GET_TIMEZONES_SUCCESS'
export const SET_TIMEZONE = 'SET_TIMEZONE'
export const SET_TIMEZONE_SUCCESS = 'SET_TIMEZONE_SUCCESS'
export const RESET_TIMEZONES = 'RESET_TIMEZONES'
